import Axios from 'axios'

// constant
import * as types from '../types'
import { host } from '../../../../host'

// helper
import catchErrorApi from '../../../../helper/catchErrorApi'
import autoDownloadFromBlob from '../../../../helper/autoDownloadFromBlob'

const apiGetReportDetailedCustomerJourney = `${host}admin/exportJSON/reportDetailedCustomerJourney`

export const getReportDetailedCustomerJourney = ({
    FromDate,
    ToDate,
    BranchIDs,
    ServiceCode,
    ReportCodeName,
    BranchName,
    CustomerType,
    ServiceTypes
}) => async (dispatch) => {
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        ServiceCode,
        ReportCodeName,
        BranchName,
        CustomerType,
        ServiceTypes
    })

    try {
        const res = await Axios.post(
            apiGetReportDetailedCustomerJourney,
            dataRequest
        )
        const { data } = res
        dispatch({
            type: types.GET_REPORT_DETAILED_CUSTOMER_JOURNEY,
            payload: {
                condFilter: {
                    FromDate,
                    ToDate,
                    BranchIDs,
                    ServiceCode,
                    ReportCodeName,
                    BranchName,
                    CustomerType,
                    ServiceTypes
                },
                listData: data.Data || [],
            },
        })
    } catch (err) {
        catchErrorApi(
            err,
            dispatch,
            types.GET_REPORT_DETAILED_CUSTOMER_JOURNEY_ERROR,
            () => false
        )
    }
}

export const exportReportDetailedCustomerJourney = ({
    FromDate,
    ToDate,
    BranchIDs,
    ServiceCode,
    ReportCodeName,
    BranchName,
    BranchCodes,
    CustomerType,
    ServiceTypes
}) => async (dispatch) => {
    if (!BranchCodes) return

    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        ServiceCode,
        ExportExcel: true,
        ReportCodeName,
        BranchName,
        CustomerType,
        ServiceTypes
    })

    try {
        const res = await Axios.post(
            apiGetReportDetailedCustomerJourney,
            dataRequest,
            {
                responseType: 'blob',
            }
        )
        const { data } = res
        if (BranchCodes.length === 1) {
            autoDownloadFromBlob(data, `${ReportCodeName}-${BranchCodes[0]}`)
        } else {
            autoDownloadFromBlob(
                data,
                `${ReportCodeName}-${BranchCodes.join('-')}`
            )
        }
    } catch (err) {
        catchErrorApi(
            err,
            dispatch,
            types.EXPORT_REPORT_DETAILED_CUSTOMER_JOURNEY_ERROR,
            () => false
        )
    }
}
